// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  instance: __t.u32(),
  x: __t.f32(),
  y: __t.f32(),
  item: __t.u16(),
  caster: __t.u16(),
  startTick: __t.u32().name("start_tick"),
  endTick: __t.u32().name("end_tick"),
});
